<template>
	<div>
		<el-button @click="selectAll" size="small" type="primary">
			Select all
		</el-button>
		<el-button @click="unselectAll" size="small" type="primary" plain>
			Unselect all
		</el-button>

		<el-button @click="selectQuestionnaires" v-if="messageQuestionnaire" size="small" type="primary" plain>
			Select questionnaires
		</el-button>

		<el-table :data="message"
			ref="past"
			:show-header="false"
			@selection-change="selectMessages"
			@row-click="toggleRow">
			<el-table-column
				type="selection"
				width="55">
			</el-table-column>
			<el-table-column width="150">
				<template slot-scope="scope">
					{{ formatDate(timestamp + scope.row.delay) }}
				</template>
			</el-table-column>
			<el-table-column>
				<template slot-scope="scope">
					<div class="message" style="line-height:18px;">
						<strong>{{ scope.row.title }}</strong><br>
						<small>{{ formatCount(Math.abs(dayDelay(scope.row)), 'day') }}
						   	{{ dayDelay(scope.row) < 0 ? 'before' : 'after' }}
						</small>
						<br>
						<p v-bind:class="['ref', scope.row.ref_type]" v-if="scope.row.ref_type">
							<i class="el-icon-link"></i>
							{{ getContentKey(scope.row.ref_type, scope.row.ref_id, 'title') }}
							<span>{{ scope.row.ref_type }}</span>
						</p>
					</div>
				</template>
			</el-table-column>
		</el-table>
		<div class="actions" style="text-align:right;margin-top:10px;">
			<el-button type="link" @click="cancel">Cancel</el-button>
			<el-button type="primary" @click="send">Create Event and Send Messages</el-button>
		</div>
	</div>
</template>
<script>
import { mapGetters } from 'vuex'
import Vue from 'vue'
import format from '@/module/util/format'

export default {
	props: {
		message: {
			type: Array
		},
		event: {
			type: Object
		},
		time: {
			type: Date
		}
	},

	data() {
		return {
			sendMessage: {}
		}
	},

	mounted() {
		this.selectAll()
	},

	methods: {
		...format,
		toggleRow(row) {
			this.$refs.past.toggleRowSelection(row)
		},
		selectAll() {
			this.setSelectedMessages(() => true, true)
		},
		unselectAll() {
			this.setSelectedMessages(() => false, true)
		},
		selectQuestionnaires() {
			this.setSelectedMessages((message) => (message.ref_type === 'questionnaire'), true)
		},
		setSelectedMessages(test, update) {
			setTimeout(() => {
				let sendMessage = {}
				if (Array.isArray(this.message))
					this.message.forEach((message, index) => {
						let selected = (test(message) === true)
						sendMessage[(message.id != null) ? message.id : index] = selected
						if (update)
							this.$refs.past.toggleRowSelection(message, selected)
					})
				else
					console.log('Invalid messages')
				this.sendMessage = sendMessage
			}, 100)
		},
		selectMessages(selection) {
			this.message.forEach((message, index) => {
				if (selection.includes(message) && this.sendMessage[message.id || index] === false)
					Vue.set(this.sendMessage, message.id || index, true)
				else if (! selection.includes(message) && this.sendMessage[message.id || index] === true)
					Vue.set(this.sendMessage, message.id || index, false)
			})
		},
		dayDelay(message) {
			if (message.dayDelay)
				return message.dayDelay
			return Math.round(message.delay / 86400000)
		},
		send() {
			this.$emit('confirm', this.sendMessage)
		},
		cancel() {
			this.$emit('cancel')
		}
	},

	computed: {
		...mapGetters('content', [
			'getContentKey'
		]),
		timestamp() {
			return new Date(this.time).getTime()
		},
		messageQuestionnaire() {
			if (Array.isArray(this.message))
				return this.message.find((message) => message.ref_type === 'questionnaire') != null
		}
	}
}
</script>

<style lang="scss" scoped>
@import "@/module/app/theme/color.scss";
.ref {
	display: inline-block;
	background: #f0f0f0;
	margin-top: 5px;
	border-radius: 15px;
	padding: 5px 15px 5px 10px;
	font-weight: 500;

	span {
		font-weight: 400;
		opacity: 0.5;
		padding-left: 5px;
	}
}
.ref.questionnaire {
	background: lighten($questionnaire-color, 50%);
}
.ref.article {
	background: lighten($article-color, 50%);
}
.ref.appointment {
	background: lighten($appointment-color, 50%);
}
</style>
